<template>
	<grid-item v-if="params.dragging" v-bind="params" class="sf-card bg sf-widget-container blank"></grid-item>
	<grid-item
		v-else
		class="sf-card bg sf-widget-container grid item"
		v-bind="params"
		:para="para"
		drag-allow-from=".sf-widget-header"
		drag-ignore-from=".sf-widget-body"
		:user="user"
	>
		<div class="sf-card__header sf-widget-header">
			<span class="title">{{ title }}</span>
			<span class="title">
				<span class="title sync-date" v-if="refreshBtn">{{ syncDate }}</span>
				<i v-if="refreshBtn" class="icon-sf-refresh" @click="onRefresh"></i>
				<i v-if="settingsBtn" class="icon-sf-setting" @click="toggleSetting"></i>
				<i class="icon-sf-close" @click="onClickDelete"></i>
			</span>
		</div>
		<div v-if="settingFlag" class="sf-widget-body p-0 h-100 sf-card___body">
			<div class="widget___settings">
				<ul>
					<li v-for="[key, val] in Object.entries(para.settings)" :key="key">
						<b>{{ key }}</b>
						<el-select v-if="getSelectOptions(key)" :value="val" @change="v => onChangeSetting(key, v)" filterable>
							<el-option v-for="option in getSelectOptions(key)" :key="option.value" :label="option.label" :value="option.value" />
						</el-select>
						<el-input v-else :value="val" @input="v => onChangeSetting(key, v)" />
					</li>
				</ul>
				<div style="width: fit-content; margin: auto">
					<sf-button line icon="file" color="blue" :onClick="onApply">{{ getMessage_('SWCC000602') }}</sf-button>
					<sf-button line icon="close" :onClick="onCancel">{{ getMessage_('SWCC000191') }}</sf-button>
				</div>
			</div>
		</div>
		<component
			v-show="!settingFlag"
			ref="widgetComponent"
			class="sf-widget-body h-100"
			:is="component"
			v-bind="params"
			:para="para"
			@change="onChange"
			@updateSyncDate="val => updateSyncDate(val)"
		/>
	</grid-item>
</template>
<script>
import { serviceComputed, serviceMethods } from '@common/Widget/store/helpers';
import { rootComputed } from '@/store/common/helpers';
import { GridItem } from 'vue-grid-layout';
export default {
	props: ['component', 'params'],

	components: { GridItem },
	mounted() {
		// this.$el.scrollIntoView();
		this.refreshPara();
	},
	methods: {
		...serviceMethods,
		onClickDelete() {
			this.deleteWidgetItem_(this.params);
		},
		onRefresh() {
			this.$sf_toggleLoading(true);
			this.$refs.widgetComponent.refresh().finally(() => this.$sf_toggleLoading(false));
		},
		onChange(params) {
			this.onChangeWidgetItem_(params);
		},
		toggleSetting() {
			this.settingFlag = !this.settingFlag;
		},
		onChangeSetting(key, val) {
			this.para.settings[key] = val;
		},
		onApply() {
			this.onChange({ i: this.params.i, settings: this.para.settings });
			this.toggleSetting();
		},
		onCancel() {
			this.refreshPara();
			this.toggleSetting();
		},
		refreshPara() {
			const definedSetting = _.get(this.widgetValues, 'parameter.settings') || {};
			const userSetting = _.pick({ ...definedSetting, ..._.get(this.widgetValues, 'para.settings') }, _.keys(definedSetting));
			this.para = { ...Object.assign(this.params.parameter || {}, { settings: userSetting }) };
			// console.log('refreshPara', this.title, this.params.i, this.para);
		},
		getSelectOptions(key) {
			const options = _.get(this.$refs.widgetComponent, `_data.${key}Options`);
			return options;
		},

		updateSyncDate(val) {
			this.syncDate = val;
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_(this.params.widgetTitle);
		},
		refreshBtn() {
			return _.get(this.params, 'parameter.refresh');
		},
		settingsBtn() {
			const v = _.get(this.params, 'parameter.settings') || {};
			return !_.isEmpty(v);
		},
		widgetValues() {
			return this.widgetItems.find(r => r.i === this.params.i);
		}
	},
	watch: {
		params() {
			this.refreshPara();
		}
	},
	data() {
		return {
			syncDate: '',
			settingFlag: false,
			para: {}
		};
	}
};
</script>
<style></style>
